import angular from 'angular';

module.exports = angular.module('market.routes.vendor_help.prospective', [])
.config(function($stateProvider) {
  $stateProvider.state('vendor_help.prospective', {
    url: '/prospective',
    template: require('./prospective.jade')(),
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/vendor-help/prospective.js
 **/